export function getReferrer(_ref) {
  let {
    req
  } = _ref;
  return req ? req.get('referer') : document.referrer;
}